export default __webpack_public_path__ + "images/ac079d83fe0ba1729485ba4ec53d4306-mindful-eating.svg";